import {useEffect} from 'react'

/**
 * A useful hook for detecting clicks outside of the current component. In the
 * handler function, you can do a comparison of the event target and a ref to
 * the component node to see if the click is outside its scope.
 * @param {Function} handler The event handler to run on `mousedown` anywhere in the document
 * @return {void}
 */
export default function useOnDocumentMousedown(handler) {
  if (typeof handler !== 'function') {
    throw new Error('useOnDocumentMousedown must be passed an event handler function')
  }

  useEffect(
    function onMount() {
      document.addEventListener('mousedown', handler)

      return function onUnmount() {
        document.removeEventListener('mousedown', handler)
      }
    },
    [handler],
  )
}
